import React from 'react';
import { render } from 'react-dom';
import { __ } from '@wordpress/i18n';

import { CalculatorFoodChecker } from '../../calculators/components/Calculator/CalculatorFoodChecker';

const langStrings = [
  __('Pet Food Checker', 'cooperpetcare'),
  __('Is it okay for my pet to eat this?', 'cooperpetcare'),
  __('Type a food here 🍐🍓🍕', 'cooperpetcare'),
  __('Search', 'cooperpetcare'),
];

document.addEventListener('DOMContentLoaded', () => {
  const blockWrapperClass = 'block-container__food-checker';
  const wrappers = document.getElementsByClassName(blockWrapperClass);

  for (let wrapper of wrappers) {
    render(<CalculatorFoodChecker />, wrapper);
  }
});
